/* CUSTOMER */
export const GET_CUSTOMER_LISTING = "GET_CUSTOMER_LISTING";
export const GET_CUSTOMER_LISTING_SUCCESS = "GET_CUSTOMER_LISTING_SUCCESS";
export const GET_CUSTOMER_LISTING_FAIL = "GET_CUSTOMER_LISTING_FAIL";

export const CREATE_CUSTOMER = "CREATE_CUSTOMER";
export const CREATE_CUSTOMER_SUCCESS = "CREATE_CUSTOMER_SUCCESS";
export const CREATE_CUSTOMER_FAIL = "CREATE_CUSTOMER_FAIL";

export const UPDATE_CUSTOMER = "UPDATE_CUSTOMER";
export const UPDATE_CUSTOMER_SUCCESS = "UPDATE_CUSTOMER_SUCCESS";
export const UPDATE_CUSTOMER_FAIL = "UPDATE_CUSTOMER_FAIL";

export const GET_CUSTOMER_DETAILS = "GET_CUSTOMER_DETAILS";
export const GET_CUSTOMER_DETAILS_SUCCESS = "GET_CUSTOMER_DETAILS_SUCCESS";
export const GET_CUSTOMER_DETAILS_FAIL = "GET_CUSTOMER_DETAILS_FAIL";

export const GET_CUSTOMER_HISTORY_LISTING = "GET_CUSTOMER_HISTORY_LISTING";
export const GET_CUSTOMER_HISTORY_LISTING_SUCCESS = "GET_CUSTOMER_HISTORY_LISTING_SUCCESS";
export const GET_CUSTOMER_HISTORY_LISTING_FAIL = "GET_CUSTOMER_HISTORY_LISTING_FAIL";

export const GET_CUSTOMER_ORDERS_LISTING = "GET_CUSTOMER_ORDERS_LISTING";
export const GET_CUSTOMER_ORDERS_LISTING_SUCCESS = "GET_CUSTOMER_ORDERS_LISTING_SUCCESS";
export const GET_CUSTOMER_ORDERS_LISTING_FAIL = "GET_CUSTOMER_ORDERS_LISTING_FAIL";

export const DELETE_CUSTOMER = "DELETE_CUSTOMER";
export const DELETE_CUSTOMER_SUCCESS = "DELETE_CUSTOMER_SUCCESS";
export const DELETE_CUSTOMER_FAIL = "DELETE_CUSTOMER_FAIL";

export const CUSTOMER_ACTIVATION = "CUSTOMER_ACTIVATION";
export const CUSTOMER_ACTIVATION_SUCCESS = "CUSTOMER_ACTIVATION_SUCCESS";
export const CUSTOMER_ACTIVATION_FAIL = "CUSTOMER_ACTIVATION_FAIL";

export const EXPORT_CUSTOMER_LISTING = "EXPORT_CUSTOMER_LISTING";
export const EXPORT_CUSTOMER_LISTING_SUCCESS = "EXPORT_CUSTOMER_LISTING_SUCCESS";
export const EXPORT_CUSTOMER_LISTING_FAIL = "EXPORT_CUSTOMER_LISTING_FAIL";

export const SWITCH_CUSTOMER_DOCTOR = "SWITCH_CUSTOMER_DOCTOR";
export const SWITCH_CUSTOMER_DOCTOR_SUCCESS = "SWITCH_CUSTOMER_DOCTOR_SUCCESS";
export const SWITCH_CUSTOMER_DOCTOR_FAIL = "SWITCH_CUSTOMER_DOCTOR_FAIL";

export const RESET_CUSTOMER_STATE = 'RESET_CUSTOMER_STATE';
export const RESET_CUSTOMER_ACTION_STATE = 'RESET_CUSTOMER_ACTION_STATE';